import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { IPermision } from '../../auth/models/IUser';
import { AuthService } from '../../auth/services/auth.service';
import {
  canHasPermission,
  checkHostOrOtherUserPermission,
} from '../helpers/permission-formate-helper';
import { StorageService } from '../helpers/storage.service';
import { Storagekeys } from '../model/storage';
export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const storage = inject(StorageService);
  const permissions = authService.getPermissions();
  const reDirectTo = storage.getItem(Storagekeys.redirectTo, true);
  const hasPermission = canHasPermission(route.data as IPermision, permissions);
  const isAuthenticated = authService.isAuthenticatedUser();
  const isHostOrOtherUser = checkHostOrOtherUserPermission(
    state.url,
    reDirectTo
  );
  if (isAuthenticated && hasPermission && isHostOrOtherUser) {
    return true;
  } else {
    router.navigate(['/auth/login']);
    return false;
  }
};
